var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.66 44.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#22bdc3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.84,0A5.88,5.88,0,0,0,14,5.86V7.61h3V5.86a2.83,2.83,0,0,1,5.66,0V7.61h3V5.86A5.87,5.87,0,0,0,19.84,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,36.91A4.09,4.09,0,0,1,19.89,41h-.1a4.09,4.09,0,0,1-4.09-4.09h-3A7.12,7.12,0,0,0,19.82,44h.1A7.12,7.12,0,0,0,27,36.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.42,36.34l-4.28-6.73V21.06a15.3,15.3,0,0,0-30.6,0v8.55L.24,36.3a1.54,1.54,0,0,0-.06,1.55,1.52,1.52,0,0,0,1.33.79H38.17a1.52,1.52,0,0,0,1.33-.79A1.54,1.54,0,0,0,39.42,36.34ZM4.29,35.61l3-4.74a1.48,1.48,0,0,0,.24-.82v-9a12.27,12.27,0,1,1,24.54,0v9a1.48,1.48,0,0,0,.24.82l3.11,4.74Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification_icon.54d4e7d8b1951abccbf63fb1c307ffdc.svg";
export { ForwardRef as ReactComponent };